import { Camera } from "lucide-react";
import { useEffect, useState } from "react";
import ScanbotSDK from "scanbot-web-sdk/ui";

const BarcodeScanner = ({ setResult }) => {
  const [scanResult, setScanResult] = useState("");

  useEffect(() => {
    const init = async () => {
      await ScanbotSDK.initialize({
        licenseKey: "",
        enginePath:
          "https://cdn.jsdelivr.net/npm/scanbot-web-sdk@latest/bundle/bin/complete/",
      });
    };

    init();
  }, []);

  const startScanner = async () => {
    const config = new ScanbotSDK.UI.Config.BarcodeScannerScreenConfiguration();

    const result = await ScanbotSDK.UI.createBarcodeScanner(config);

    if (result && result.items.length > 0) {
      setScanResult(result.items[0].barcode.text);
      setResult(result.items[0].barcode.text);
    }

    return result;
  };

  return (
    <div>
      <button onClick={startScanner} className="btn h-10 btn-sm btn-main">
        <Camera size={18} />
      </button>
      {/* {scanResult && <div>{scanResult}</div>} */}
    </div>
  );
};

export default BarcodeScanner;
